import { Divider, Flex } from '@chakra-ui/react';
import { StageMenu } from './StageMenu';

type ModestdAddButtonProps = {
   index: number;
};

export function ModestAddButton({ index }: ModestdAddButtonProps) {
   return (
      <Flex alignItems="center">
         <Divider borderBottomWidth="1px" borderColor="blueGray.600" />
         <StageMenu index={index} />
         <Divider borderBottomWidth="1px" borderColor="blueGray.600" />
      </Flex>
   );
}
